import types from './types';

export const storeInit = () => ({
  type: types.STORE_INIT
});

export const storeClear = () => ({
  type: types.STORE_CLEAR
});

export const startRequest = () => ({
  type: types.START_REQUEST
});

export const endRequest = () => ({
  type: types.END_REQUEST
});

export const openDialog = dialogInfo => ({
    type: types.OPEN_DIALOG,
    dialogInfo
});

export const closeDialog = () => ({
    type: types.CLOSE_DIALOG
});

export const closeDialogNotFormat = () => ({
    type: types.CLOSE_DIALOG_NOT_FORMAT
});

export const checkAccess = accessInfo => ({
    type: types.CHECK_ACCESS,
    accessInfo
});

export default {
  storeInit,
  storeClear,
  startRequest,
  endRequest,
  openDialog,
  closeDialog,
  checkAccess,
};
